
function get (value, path, defaultValue) {
  const array = typeof path === 'string' ? String(path).split('.') : path

  return array.reduce((acc, v) => {
    try {
      acc = typeof acc[v] === 'boolean' ? acc[v] : (acc[v] || defaultValue)
    } catch (e) {
      return defaultValue
    }
    return acc
  }, value)
}

export default get
